const KitchenRenovations = [
  {
    hideHeading: true,
  },
  {
    tag: 'h2',
    heading: 'What is included in a kitchen renovation and design?',
    description: `Most kitchen renovations include the following features and upgrades:`,
    faqs: [
      {
        tag: 'h3',
        q: 'Designing',
        a: `Some kitchen designers are not involved with the building process, whilst others help at every stage of the project. In the initial stages, renovators must work with clients to ensure that their needs are met, apply for relevant building permits, tear down the old kitchen, and ensure that all old materials are disposed of responsibly. They must also come up with some preliminary kitchen ideas and kitchen designs.`,
      },
      {
        tag: 'h3',
        q: 'Upgrade and install cabinetry',
        a: `A cabinetry upgrade can transform the look and feel of a kitchen and tends to include the instalment of mounted cabinets and cabinets that rest on the ground. There are many different cabinet styles out there for homeowners to choose from, including:
<br><br>
        <h4>Traditional</h4>
        <br>These cabinets are often very detailed and sometimes include raised-panel doors. They are usually fashioned from wood and are often painted a colour that fits in with the rest of the kitchen. Many traditional styles also include inset recessed doors.
        <br><br>
        <h4>Contemporary</h4>
        <br>        Contemporary cabinets tend to be minimalist and come in a range of materials such as glass, metal, or plastic. What’s more, they often include sleek and technologically innovative cabinet handles.
        <br><br>
        <h4>Glass-fronted</h4><br>
        Installing glass cabinets can be an eye-catching way of showing off your best crockery and glassware.
        `,
      },
      {
        tag: 'h3',
        q: 'Increase storage',
        a: `A kitchen upgrade is an excellent excuse to boost the amount of storage available in your kitchen for food, cutlery, crockery, and more. Even if your kitchen is small, you can add storage space with smart solutions such as installing more wall-mounted cabinetry and coming up with a new space-saving room layout. An experienced kitchen renovator or designer will be able to come up with innovative storage solutions.`,
      },
      {
        tag: 'h3',
        q: 'Upgrade lighting',
        a: `Lighting is one of the most important elements of a kitchen and can significantly impact the atmosphere of the room. There are many different lighting styles for homeowners to choose from for kitchen renovations including spotlights, cabinet lights, hanging lamps, recessed lights, pendant lamps, and more. Clients can work with kitchen renovators to come up with a lighting scheme that accounts for the overall aesthetic of the room whilst taking into account any wiring issues.`,
      },
      {
        tag: 'h3',
        q: 'Upgrade kitchen fixtures',
        a: `A kitchen renovation represents the perfect opportunity to upgrade kitchen fixtures including oven hoods, wine racks, tables, stools and more. An expert kitchen designer will be able to source sleek fixtures that are both functional and beautiful.`,
      },
      {
        tag: 'h3',
        q: 'Add a splashback',
        a: `Splashbacks help to protect walls and floors from the unfortunate spills and messy accidents that occur in the kitchen on a regular basis. Many homeowners opt for wall tiles as a protective barrier, although clients are increasingly coming up with more unusual kitchen splashback ideas using materials such as metal sheets, particularly in minimalist kitchens.`,
      },
      {
        tag: 'h3',
        q: 'Add a kitchen island',
        a: `An island can add a focal point to a kitchen, as well as being amazingly functional. On top of improving the amount of storage and preparation space in the room, it can function as an informal dining area or a place to seat and entertain guests whilst you are cooking.`,
      },
      {
        tag: 'h3',
        q: 'Update appliances',
        a: `It is important that homeowners update their appliances every few years or so to ensure that they run as efficiently as possible. Kitchen renovators can help to install an array of vital appliances including ovens, washing machines, dishwashers, refrigerators, and more, as well as safely dispose of old, worn-out models.`,
      },
      {
        tag: 'h3',
        q: 'Repairing old structures',
        a: `Once the flooring and cabinetry have been removed, it is often necessary to patch up scratches and holes in the walls and ceiling before work goes ahead.

        `,
      },
      {
        tag: 'h3',
        q: 'Assessing the electrics',
        a: `Sometimes, the kitchen will need rewiring to accommodate new lights or to install appliances. Some renovators enlist help from electricians for this task.

        `,
      },
      {
        tag: 'h3',
        q: 'Assessing the plumbing',
        a: `It is vital that any faulty pipes are replaced, and all faulty connections are resolved before going ahead with the renovation. Gas lines may also need to be established if the client requires a new oven.`,
      },
      {
        tag: 'h3',
        q: 'Installing the flooring',
        a: `From tile to lino, kitchen renovators must be able to install a wide range of flooring types.`,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'Popular kitchen design styles',
    description: `Any renovator with experience knows that every kitchen is unique. However, most kitchens can be categorised according to a certain design style or function. Some of the most popular include:`,
    faqs: [
      {
        tag: 'h3',
        q: 'Hampton style kitchens',
        a: `Hampton design is all about luxury, elegance, comfort and functionality, making it the perfect style option for family-oriented homeowners who love to use their kitchen for everything from hosting refined gatherings to baking with their kids. Generally speaking, Hampton style kitchens will include some of the following features:
        <ul>
        <li>Neutral colours such as cream, white, and ivory. Accent colours may appear in choice areas of the room and tend to include deep shades such as navy or plum.</li>
        <li>Natural materials that may be used to fashion wood floors, marble countertops, and traditional cabinets.</li>
        <li>Lots of natural light and an airy feel.</li>
        </ul>
        `,
      },
      {
        tag: 'h3',
        q: 'Modern kitchens',
        a: `Modern kitchens tend to be minimalist and include cutting-edge materials and technologies. When coming up with a modern kitchen design, renovators will often come up with functional solutions that make household tasks easier than ever before. Modern kitchen features may include:
       <ul> <li>Smart lighting solutions that highlight food preparation spaces and give the room a welcoming atmosphere.</li>
       <li>Innovative appliances and technologies.</li>
       <li>Durable flooring and countertops that are sleek and easy to clean.</li>
        </ul>
        `,
      },
      {
        tag: 'h3',
        q: 'Small kitchens',
        a: `Small kitchens can be frustrating for homeowners as they can feel restrictive in terms of storage space and may cause claustrophobia, particularly during parties and gatherings. Fortunately, there are things that kitchen renovators can do to maximise the space available and make the room feel airier and more spacious than ever before. This could include boosting storage space through extra cabinets, making the room feel lighter by adding glass fixtures and changing the colour scheme, or even knocking down a wall to merge the kitchen area with another room.`,
      },
      {
        tag: 'h3',
        q: 'Country style kitchens',
        a: `Country style kitchens are excellent for homeowners who like their rooms to feel cosy and comforting. Typical country style kitchens include features such as:
       <ul> <li>A colour scheme that includes plenty of soft pastels and light tones.</li>
       <li>Vintage elements such as flowery tiles or intricately carved cabinets.</li>
       <li>A large, rustic oven.</li>
       <li>Wood features.</li>
        </ul>
        `,
      },
      {
        tag: 'h3',
        q: 'Industrial kitchens',
        a: `Industrial kitchens are all about embodying functionality whilst making a style statement. When executed properly, they can give properties a unique, often strangely cosy feel. Typical features of an industrial kitchen include:
        <ul><li>Exposed pipes and brick walls.</li>
        <li>Plenty of metal. Stainless steel may be used for the countertop, for example.</li>
        <li>Retro appliances.</li></ul>
        `,
      },
      {
        tag: 'h3',
        q: 'French provincial kitchens',
        a: `If you want a kitchen that feels both quaint and modern, a French provincial style kitchen may be the perfect solution. Key features of this style include:
        <ul><li>Hand-painted walls and furniture.</li>
        <li>Granite, tile or timber counters.</li>
        <li>Cabinet handles made from traditional wrought iron.</li>
        <li>Kitchen sinks made from gorgeous white porcelain.</li>
        <li>Kitchen islands perfect for socialising and preparing meals on.</li>
        </ul>
        `,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'FAQ about kitchen renovations and designers in Australia',
    faqs: [
      {
        tag: 'h3',
        q: `How long do kitchen renovations take?`,
        a: `The length of time it takes to fit your kitchen will depend on the size of your kitchen and how drastic the changes will be. For example, if your kitchen requires a significant amount of structural changes or rewiring, then it may take a little longer. Some materials may also be harder to source than others. As a general guide, however, kitchen renovations usually take between six and eight weeks.`,
      },
      {
        tag: 'h3',
        q: `Will I need council approval for kitchen renovations?`,
        a: `Most kitchen renovations do not require council approval. However, you may need to obtain permissions if your kitchen involves external work or a building extension.`,
      },
      {
        tag: 'h3',
        q: `What is the average cost of a kitchen renovation in Australia?`,
        a: `The average cost of a kitchen renovation in Australia is around $17,000. However, kitchen prices can vary dramatically. For example, if you want a luxury kitchen full of expensive materials, you can expect to pay upwards of $100,000. Furthermore, if you are in an expensive area such as Sydney, the price is likely to be higher. `,
      },
      {
        tag: 'h3',
        q: `What is the difference between flat-pack and custom kitchen cabinets?`,
        a: `The primary difference between custom kitchen cabinets and flat-pack versions is that the latter can be constructed by inexperienced homeowners, whilst the former need to be installed by professional kitchen renovators.`,
      },
      {
        tag: 'h3',
        q: `What is a flat-pack kitchen?`,
        a: `A flat-pack kitchen can be assembled by a homeowner and will usually come in a number of separate packages with easy-to-follow instructions. These kitchen packages include, for example, fittings, handles, benchtops, cabinets, and drawer runners. A DIY kitchen represents a riskier option than professionally constructed kitchens as they can be easy to get wrong and may not look as sleek once assembled.`,
      },
      {
        tag: 'h3',
        q: `Can I live in my house while my kitchen is being renovated?`,
        a: `Yes. Most kitchen renovators will work with homeowners to ensure that key amenities are reachable during the construction. You may, however, need to live off microwave meals for a couple of weeks. Many people choose to live with friends or family for a short period whilst their kitchens are being constructed.`,
      },
      {
        tag: 'h3',
        q: `Will I need to hire other trades like plumbers and electricians when renovating my kitchen?`,
        a: `This depends on the expertise of your tradesperson. Sometimes, a kitchen renovator will be able to complete all of the relevant electric and plumbing work to a very high standard. They may also work closely with certain electricians and plumbers on a regular basis, in which case they will make arrangements for the work to be carried out.

        `,
      },
      {
        tag: 'h3',
        q: `What materials are commonly used in kitchen design and renovations?`,
        a: `Kitchen renovators use a broad array of materials to ensure that each and every project they work on is unique and looks fantastic. These include:
<br><br>
<h4>Glass</h4>

        <br>
        Glass can add a real touch of minimalist class to a kitchen and can be used in a variety of fixtures including cabinet doors, countertops, and splashbacks. It also comes in a variety of styles, colours and textures, including frosted, mirrored, tinted, coated, and float glass.
        <br><br>
        <h4>Stone</h4>
        <br>
        Stone is a hardwearing material that works for homeowners hoping to create a rustic look. It can be used in a variety of features including flooring, countertops, splashbacks, and other features.
        <br><br><h4>Marble</h4>

        <br>
        Marble is a chic material that will suit homeowners hoping to achieve a luxe design for their kitchen. It is primarily used as a countertop material but may also work well as flooring or to make kitchen tiles.
        <br><br><h4>Tiles</h4>

        <br>
        Tiles are often used in kitchen splashbacks, although they may also be used as flooring. One of the best things about tiles is that they come in an almost endless array of colours and styles, meaning it is easy to find tiles that stunningly complement the rest of the kitchen.
        <br><br><h4>Laminate</h4>

        <br>
        Laminate flooring is very common in modern kitchens and many styles can very successfully imitate the appearance of real wood floors. Unlike real wood floors, however, laminate is very cost-effective and can be cleaned easily. In this way, it is a great option for big families with children who are prone to making a mess in the kitchen.
        <br><br><h4>Stainless steel</h4>

        <br>
        Stainless steel is present in almost all kitchens as it is used to craft contemporary sinks and taps. Clients may decide to extend the use of stainless steel into other areas of the kitchen such as countertops and splashbacks, however. As well as being corrosion-resistant and amazingly easy to wipe clean, stainless steel can be aesthetically striking.
        <br><br><h4>Timber</h4>

        <br>
        Timber is an excellent material for those who want their kitchen to feel rustic and homely. It can be used in a vast array of applications including flooring, cabinetry, fixtures for storage, and preparation surfaces.
        `,
      },
      {
        tag: 'h3',
        q: `Where can I find the best kitchen renovators and designers near me?`,
        a: `Localsearch is the best comparison site for kitchen design in Australia, allowing you to weigh up the pros and cons of different kitchen renovators and designers. It includes all of the relevant details such as rates, expertise, location and availability.
<br><br>
        <h4>Compare quotes</h4>
        <br>
        Localsearch allows you to compare quotes in seconds, making the process of finding a kitchen renovator you can afford easier than ever.
        <br><br>
        <h4>Read reviews</h4>
        <br>
        Localsearch includes plenty of helpful reviews from homeowners just like you. This allows you to easily weigh up the benefits of individual contractors based on testimony you know you can trust.
        <br><br>
        <h4>View portfolios, past work and image galleries</h4>
        <br>
        Viewing past work or portfolios can help when it comes to hiring the best kitchen renovators and designers near you.
        `,
      },
    ],
  },
];

export default KitchenRenovations;
